<template>
  <div slider :class="type">
    <div class="swiper-container">
      <ul class="swiper-wrapper">
        <slot></slot>
      </ul>
    </div>
    <div class="swiper-pagination" v-if="pagination"></div>
    <div class="swiper-navigation" v-if="navigation">
      <a class="swiper-button-prev"></a>
      <a class="swiper-button-next"></a>
    </div>
  </div>
</template>

<style lang="less">
@import "../less/asset";
@import "../less/gynpad";

[slider] {
  .swiper-slide { .border-box; }

  &.main { .rel;
    .swiper-pagination { .lb-r(10,18);
      .swiper-pagination-bullet { .ib; .rw(20); background:none; opacity:0.3; .tc; .rp-b(20); .rel; .vab; transition: all 0.2s;
        .swiper-pagination-link { .karla; .bold; .hide; }
        &:after { content:''; .block; .lb-r(9,0); .rw(2); .rh(10); background: #222; }

        &.active { opacity: 1; .rp-b(27);
          .swiper-pagination-link { .block; }
          &:after { .rh(16); }
        }
      }
    }
  }

  &.phone-case { .rel;
    .swiper-button-prev { .contain('@{i-decide}/arrow-left.svg'); .rwh(13,25); left:30px; }
    .swiper-button-next { .contain('@{i-decide}/arrow-right.svg'); .rwh(13,25); right:30px; }
  }
}

@media (min-width: @screen-lg-min) {
  [slider] {
    &.main {
      .swiper-pagination { .rt(20px,calc(~"50vh - 70px")); width: 30px; .tr;
        .swiper-pagination-bullet { padding:0; margin-bottom:15px;
          &:after { .wh(15px,3px); .rb; transition: all 0.2s; }
          &.active { opacity: 1; padding:0;
            .swiper-pagination-link { .hide; }
            &:after { .wh(29px,3px); }
          }
        }
      }
    }

    &.phone-case {
      .swiper-button-prev { transform: rotate(90deg); left:auto; right:-115px; top:5px; .wh(23px, 42px); }
      .swiper-button-next { transform: rotate(90deg); bottom:0; top:auto; right:-115px; .wh(23px, 42px); }
    }
  }
}
</style>

<script>
import _ from 'lodash';
import Swiper from 'swiper';
import { addClass } from '../util';

export default {
  name: 'Slider',
  props: {
    pagination: { default: true },
    navigation: { default: false },
    option: Object,
    type: String,
  },
  data() {
    return {
      slider: null,
      intervalID: -1,
      opt: null,
    };
  },
  mounted() {
    this.intervalID = setInterval(() => {
      if (_.every(this.$el.querySelectorAll('img'), e => e.complete)) {
        window.clearInterval(this.intervalID);
        this.opt = _.extend({
          loop: true,
        }, this.$props.option);
        if (this.$props.pagination) {
          this.opt.pagination = {
            el: this.$el.querySelector('.swiper-pagination'),
            renderBullet: (index, className) => `<span class="${className}"><a class="swiper-pagination-link">0${index + 1}</a></span>`,
            bulletActiveClass: 'active',
            clickable: true,
          };
        }

        if (this.$el.querySelector('.swiper-wrapper .swiper-slide') === null) {
          _.forEach(this.$el.querySelectorAll('.swiper-wrapper > li'), (e) => {
            addClass(e, 'swiper-slide');
          });
        }

        if (this.$props.navigation) {
          this.opt.navigation = {
            nextEl: this.$el.querySelector('.swiper-button-next'),
            prevEl: this.$el.querySelector('.swiper-button-prev'),
          };
        }

        this.slider = new Swiper(
          this.$el.querySelector('.swiper-container'),
          this.opt,
        );
      }
    }, 30);
  },
  methods: {
    beforeDestroy() {
      this.slider.destroy();
    },
    stopAuto() {
      this.slider.autoplay.stop();
    },
    updated() {
      if (this.slider) this.slider.update();
    },
    startAuto() {
      this.slider.autoplay.start();
    },
    prev() {
      this.slider.slidePrev();
    },
    next() {
      this.slider.slideNext();
    },
    goToSlide(index) {
      this.slider.slideTo(index);
    },
    now() {
      return this.slider ? this.slider.realIndex : 0;
    },
    disable() {
      if (this.slider) {
        this.slider.destroy(true, false);
        this.$el.querySelector('.swiper-wrapper').style.transform = 'none';
      }
    },
    enable() {
      this.slider = new Swiper(
        this.$el.querySelector('.swiper-container'),
        this.opt,
      );
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/Slider.vue